import { Document, Page, Text, View, pdf } from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";
import { Header } from "./components/header/Header";
import { CustomerData } from "./components/customerData/CustomerData";
import { ProductsData } from "./components/productsData/ProductsData";
import { BlankFooter } from "./components/blankFooter/BlankFooter";
import { generalStyles } from "./styles/generalStyles";
import { FooterInLastPage } from "./components/footerInLastPage/FooterInLastPage";


export const SalesPreorderPDF = () => {
  const {  pageNumberAndTotalPages, pdfGenerationDate } =
    generalStyles();

  const [t, i18next] = useTranslation("global");

  let pages: number;
  let regex = /\([^)]*\)/g;
  let fontFamily = "Noto Sans";

  const currentDate = new Date();

  const generatePDF = async ({ data }: any) => {
    // const desiredLength = 5;
    // const repeatedData = [];

    // while (repeatedData.length < desiredLength) {
    //   repeatedData.push(...data?.dataSalesPreordersDetails);
    // }

    // data.dataSalesPreordersDetails = repeatedData.slice(0, desiredLength);

    // const generateDescription = (length: number) => {
    //   const lorem = "Lorem ipsum dolor sit amet consectetur adipiscing elit ".repeat(50);
    //   return lorem.slice(0, length).trim() + (length >= 1000 ? "..." : "");
    // };

    // data.dataSalesPreordersDetails = data.dataSalesPreordersDetails.map((item: any, index: number) => ({
    //   ...item,
    //   item_description: generateDescription([500, 300, 1200, 800, 1500][index % 5])
    // }));


    if (
      !data.dataSalesPreorders.customer_language ||
      data.dataSalesPreorders.customer_language === " " ||
      data.dataSalesPreorders.customer_language.toLowerCase() === "es"
    ) {
      data.dataSalesPreorders.customer_language = "es";
    }

    if (data.dataSalesPreorders.customer_language.toLowerCase() === "zh") {
      fontFamily = "Noto Sans SC";
    }

    const showTranslatedText = (key: string) => {
      return t(key, {
        lng: data.dataSalesPreorders.customer_language.toLowerCase(),
      });
    };

    const content = (
      <Document>
        <Page size={"A4"} style={{
          paddingTop: 240,
          paddingBottom: 130,
          paddingHorizontal: 22,
          position: 'relative',
          fontFamily: fontFamily,
          fontWeight: 400
        }}>
          <Text
            render={({ pageNumber, totalPages }) => {
              pages = totalPages;
              return <Text></Text>;
            }}
            fixed
          />

          <View fixed style={{ position: 'absolute', top: 40, left: 22, right: 22 }}>
            <Header data={data} showTranslatedText={showTranslatedText} />

            <>
              <CustomerData
                data={data}
                showTranslatedText={showTranslatedText}
              />
              {/* 
              <PaymentData
                data={data}
                showTranslatedText={showTranslatedText}
              /> */}
            </>
          </View>

          <ProductsData
            data={data}
            showTranslatedText={showTranslatedText}
          />

          <View fixed style={{ flexGrow: 1 }}></View>


          <View style={{ position: 'absolute', bottom: 40, left: 22, right: 22 }}
            render={({ pageNumber }: { pageNumber: number }) =>
              pageNumber < pages ? (
                <BlankFooter
                  data={data}
                  showTranslatedText={showTranslatedText}
                />
              ) : (
                <FooterInLastPage
                  data={data}
                  showTranslatedText={showTranslatedText}
                />
              )
            }
            fixed
          />

          <Text
            style={pageNumberAndTotalPages.text}
            render={({ pageNumber, totalPages }) => {
              return <Text>{`Page ${pageNumber} / ${totalPages}`}</Text>;
            }}
            fixed
          />

          <Text style={pdfGenerationDate.text} fixed>
            {currentDate.toString().replace(regex, "").trim()}
          </Text>
        </Page>
      </Document>
    );

    const downloadLink = document.createElement("a");
    const fileName = `${data.dataSalesPreorders?.sales_preorder_name || " "}`;
    const blob = await pdf(content).toBlob();
    const url = URL.createObjectURL(blob);
    downloadLink.href = url;
    downloadLink.download = fileName;
    downloadLink.click();
    URL.revokeObjectURL(url);

    const reader = new FileReader();
    await reader.readAsDataURL(blob);

    return new Promise((resolve, reject) => {
      reader.onloadend = () => {
        const base64String = reader.result;
        resolve(base64String);
      };
    });
  };

  return {
    generatePDF,
  };
};
